export const PERSONAL_WORKSPACE_ID = 'my'
export const LAST_WORKSPACE_KEY = 'last_workspace'
export const LAST_WORKSPACE_TTL = 30 * 24 * 60 * 60 * 1000
